__turbopack_context__.v({
  "my_list_nav": "MyListNav-module-scss-module__LjSibW__my_list_nav",
  "my_list_nav_link": "MyListNav-module-scss-module__LjSibW__my_list_nav_link",
});
